import { ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";
import { IoClose } from "react-icons/io5";

export interface IBaseModalProps extends React.ComponentPropsWithoutRef<"div"> {
  isOpen: boolean;
  title?: string;
  styles?: string;
  onClose: () => void;
  children: ReactNode;
}

export default function BaseModal({
  isOpen,
  title,
  styles = "",
  onClose,
  children,
}: IBaseModalProps) {
  useEffect(() => {
    if (isOpen) {
      window.document.body.style.overflow = "hidden";
    }
    return () => {
      window.document.body.style.overflow = "auto";
    };
  }, [isOpen]);
  return (
    isOpen &&
    createPortal(
      <div className="modal-layout">
        <div className={`modal center overflow-auto ${styles}`}>
          {/* Modal Head -> 타이틀, close버튼*/}
          <div className="modal-title">
            <h3 className="">
              <span>{title}</span>
              <button onClick={onClose}>
                <IoClose size={28} color={""} style={{ marginTop: -15 }} />
              </button>
            </h3>
          </div>
          {/* Modal Body -> 내용*/}
          <div>{children}</div>
          {/* Modal Footer -> 확인, 취소 버튼 영역*/}
        </div>
      </div>,
      document.body
    )
  );
}
